import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function PriveSpotlight() {
  const { user } = useAuth();
  const member = Boolean(user?.prive);

  return (
    <section
      data-testid="prive-spotlight"
      className="relative overflow-hidden bg-obsidian text-ivory border-y border-gold/25"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_85%_50%,rgba(212,175,55,0.22),transparent_55%)] pointer-events-none" />
      <img
        src="/brand/logo-seal.png"
        alt=""
        aria-hidden="true"
        className="absolute -left-10 -bottom-16 w-56 opacity-[0.06] pointer-events-none"
      />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative max-w-[1400px] mx-auto px-6 lg:px-12 py-8 md:py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6"
      >
        <div className="flex items-start md:items-center gap-4">
          <span className="mt-0.5 md:mt-0 w-11 h-11 shrink-0 rounded-full border border-gold/50 flex items-center justify-center bg-ink/40">
            <Crown size={17} className="text-gold-light" />
          </span>
          <div>
            <p className="text-[10px] tracking-[0.5em] uppercase text-gold-light">ATW Privé · By invitation</p>
            <p className="mt-2 font-serif text-2xl md:text-3xl tracking-tight leading-snug max-w-xl">
              {member ? (
                <>Welcome back — your <span className="italic text-gold-light">early access</span> is live.</>
              ) : (
                <>Unlock <span className="italic text-gold-light">early access</span> to new releases & numbered editions.</>
              )}
            </p>
          </div>
        </div>
        <Link
          to={user ? "/account" : "/auth"}
          data-testid="prive-spotlight-cta"
          className="group inline-flex items-center justify-center gap-2.5 shrink-0 bg-gold-light text-ink px-7 py-4 text-[11px] tracking-[0.28em] uppercase font-medium hover:bg-ivory transition-colors"
        >
          {member ? "View the next release" : user ? "Enter invitation code" : "Join ATW Privé — free"}
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </motion.div>
    </section>
  );
}
